import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-setting-overview',
  templateUrl: './setting-overview.component.html',
  styleUrls: ['./setting-overview.component.scss']
})
export class SettingOverviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
